import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api, type AgentData } from '../lib/api';

export function useAgents() {
  return useQuery({
    queryKey: ['agents'],
    queryFn: api.listAgents,
    refetchInterval: 30_000,
  });
}

export function useAgent(name: string | null) {
  return useQuery({
    queryKey: ['agents', name],
    queryFn: () => api.getAgent(name!),
    enabled: !!name,
  });
}

export function useSaveAgent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ name, body }: { name: string; body: Record<string, unknown> }) =>
      api.saveAgent(name, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['agents'] });
    },
  });
}

export function useDeleteAgent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (name: string) => api.deleteAgent(name),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['agents'] });
    },
  });
}

export function useTestAgent() {
  return useMutation({
    mutationFn: ({ name, text }: { name: string; text: string }) =>
      api.testAgent(name, text),
  });
}

export function useReload() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.reload,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['agents'] });
    },
  });
}
